import { OutputDocumentViewModel } from "models/OutputDocumentViewModel";
import { createContext } from "react";

export interface OutputDocumentsContextProps {
  meetingLinks: OutputDocumentViewModel[];
  agendaItemLinks: OutputDocumentViewModel[];
  isLoading: boolean;
  meetingOpen: boolean;
  setMeetingOpen: (open: boolean) => void;
  agendaItemOpen: boolean;
  setAgendaItemOpen: (open: boolean) => void;
  showAgendaItemsWarnings: boolean;
  showParticipantsWarnings: boolean;
}

export const OutputDocumentsContext = createContext({} as OutputDocumentsContextProps);
